import axios from "axios";
import { ILocationQueryLabel, IResponse } from "redmond";
import { config } from "../../config";

import { locationAutocompleteApiPrefix } from "../paths";

export const fetchLocationAutocomplete = async (
  body: ILocationQueryLabel
): Promise<IResponse> => {
  const res = await axios.post(
    locationAutocompleteApiPrefix,
    {
      query: { ...body, l: body.l || "" },
    },
    {
      baseURL: config.baseURL,
    }
  );

  if (res.status === 499) {
    throw new Error();
  }

  return res.data;
};
